import { Entity } from '@adornis/baseql/decorators.js';
import { BaseEditExtension } from '../BaseEditExtension.js';

/**
 * @entity BaseKPFEditProductExtension
 */
@Entity()
export class BaseKPFEditProductExtension extends BaseEditExtension {
  public static override _class = 'BaseKPFEditProductExtension';
}
